// extracted by mini-css-extract-plugin
module.exports = {"statItem":"_02712f2b3b--statItem--HUm4l"};